/* global moment */

/*
 * cookie consent section
 */
(function () {

	"use strict";

	// set the locale based on the user's browser
	moment.locale(window.navigator.languages || window.navigator.language);

	function setDNTCookie (value) {

		// set a cookie to expire in 1 year
		const now = new Date();
		const expires = moment().add(1, "year");

		// set hostname for all sub-domains of qualys.com
		let hostname = window.location.hostname;
		if (hostname.match(/qualys\.com$/)) {
			hostname = ".qualys.com";
		}
		const cookie = [
			"dnt=" + ((value === 0 || value === "0" || !value) ? "0" : "1"),
			`domain=${hostname}`,
			"path=/",
			"expires=" + expires.toDate().toUTCString(),
			((window.location.protocol === "https:") ? "secure=yes" : null)
		].join("; ");
		document.cookie = cookie;

		// store expiration date in local storage so it may be retrieved later
		if (window.localStorage) {

			// document date and IP address when consent was given
			localStorage.setItem("dntConsent", JSON.stringify({
				"date": now.toISOString(),
				"dnt": ((value === 0 || value === "0" || !value) ? "0" : "1"),
				"ip": sessionStorage.getItem("ipify.ip")
			}));

		}

		setTimeout(function () {

			window.location.reload();

		}, 600);

	}

	function allowTrackingForOneYear () {

		this.disabled = "disabled";
		buttonRevoke.disabled = "disabled";
		buttonRevoke.removeAttribute("checked");
		if (this.nextElementSibling) {
			this.nextElementSibling.innerHTML = "Saving …";
		}
		setDNTCookie(false);

	}

	function disallowTrackingForOneYear () {

		this.disabled = "disabled";
		buttonGive.disabled = "disabled";
		buttonGive.removeAttribute("checked");
		if (this.nextElementSibling) {
			this.nextElementSibling.innerHTML = "Saving …";
		}
		setDNTCookie(true);

	}

	// helper function to update time elements
	function updateTimeElements(timestamp) {

		const timeElements = document.querySelectorAll("time");
		for (let i = 0, l = timeElements.length; i < l; i += 1) {

			const timeElement = timeElements[i];
			if (timestamp) {

				// date and time are known
				const datetime = moment(timestamp).tz(moment.tz.guess());
				timeElement.setAttribute("datetime", datetime.format());
				timeElement.innerHTML = datetime.format("LLLL z");

			} else {

				// unusal case where date and time are unknown
				timeElement.removeAttribute("datetime");
				timeElement.innerHTML = "some unknown date";

			}

		}

	}

	// bind callbacks to buttons
	const buttonGive = document.querySelector("#yes_i_accept_cookies");
	if (buttonGive) {
		buttonGive.addEventListener("click", allowTrackingForOneYear);
	}
	const buttonRevoke = document.querySelector("#no_thanks");
	if (buttonRevoke) {
		buttonRevoke.addEventListener("click", disallowTrackingForOneYear);
	}

	// update start and end dates for consent
	// based on cookie expiration date in local storage
	if (document.cookie.match(/\bdnt=[01]\b/)) {

		// check new "dntConsent" item
		// and check old "dntExpires" item
		const dntConsent = localStorage.getItem("dntConsent");
		const endDate = localStorage.getItem("dntExpires");
		if (dntConsent) {

			// prefer new "dntConsent" item
			const data = JSON.parse(dntConsent);
			if (data.date) {

				const start = moment.parseZone(data.date);
				updateTimeElements(start);

			}

			// report documented IP address
			if (data.ip) {

				const ipElements = document.querySelectorAll(".cookie-consent-ip-address");
				if (ipElements) {
					for (let i = 0, l = ipElements.length; i < l; i += 1) {

						ipElements[i].innerHTML = data.ip;

					}
				}

				const ipTexts = document.querySelectorAll(".cookie-consent-ip-address-text");
				if (ipTexts) {
					for (let i = 0, l = ipTexts.length; i < l; i += 1) {

						ipTexts[i].classList.remove("hidden");

					}
				}

			}

		} else if (endDate) {

			// fallback back to old "dntExpires" item
			const start = moment.parseZone(endDate).subtract(1, "year");
			updateTimeElements(start);

		} else {

			/* eslint-disable no-console */
			console.warn("DNT cookie found without related data in local storage.");
			updateTimeElements();
			/* eslint-enable no-console */

		}

	}

	// show the relavent section based on cookie
	if (document.cookie.match(/\bdnt=0\b/)) {

		// show the consent given section
		const consentYes = document.querySelector(".cookie-consent-yes");
		if (consentYes) {
			consentYes.classList.remove("hidden");
		}

		// select the Yes checkbox
		buttonGive.setAttribute("checked", "checked");

	} else if (document.cookie.match(/\bdnt=1\b/)) {

		// show the consent not given section
		const consentNo = document.querySelector(".cookie-consent-no");
		if (consentNo) {
			consentNo.classList.remove("hidden");
		}

		// select the No checkbox
		buttonRevoke.setAttribute("checked", "checked");

	} else {

		// show the Unknown Consent section
		const consentUnknown = document.querySelector(".cookie-consent-unknown");
		if (consentUnknown) {
			consentUnknown.classList.remove("hidden");
		}

	}

	// find and store the "checking consent" element
	const consentCheck = document.querySelector(".cookie-consent-checking");
	if (consentCheck) {
		consentCheck.classList.add("hidden");
	}

}());
